<template>
  <div class="newsCenterIndex">
    <!-- 内容 -->
    <div class="content-box">
      <div class="tabBox">
        <div class="tabBox-menu">
          <div
            v-for="(item, index) in menuArr"
            :key="index"
            @click="goAnchor(index)"
            :class="index == type ? 'bianse' : ''"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <!-- 列表 -->
      <div class="list-box">
        <div class="list-box-box" v-show="listArr.length>0">
          <div
            class="every-list"
            v-for="(item, index) in listArr"
            :key="index"
            @mousemove="listMove(index)"
            @mouseleave="listMoveLeave()"
            @click="listDetails(item.press_id)"
          >
            <div class="content">
              <div class="img-box">
                <img :src="item.icon" alt="" />
              </div>
              <div class="text-box">
                <div class="name">{{item.title}}</div>
                <div class="time">{{item.create_time}}</div>
                <!-- <div class="jieshao">{{item.title}}</div> -->
              </div>
            </div>
            <transition name="el-zoom-in-bottom">
              <div class="tanchuang" v-show="mousemoveIndex == index">
                <div class="text-box">
                  <div class="name">{{item.title}}</div>
                  <div class="time">{{item.create_time}}</div>
                  <!-- <div class="jieshao">
                    详情内容详情内容详情内容详情内容详情内容详情 内容详情内容
                  </div> -->
                </div>
              </div>
            </transition>
          </div>
        </div>
        <div class="fenye" v-show="listArr.length>0">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="listTotal"
            :pageSize="pageSize"
            :current-page="pageNumber"
            @current-change="currentChange"
          ></el-pagination>
        </div>
        <img v-show="listArr.length<=0" class="zanwu" src="../assets/zanwu.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import { pressCenter } from "@/request/api";
export default {
  name: "NewsCenterIndex",
  data() {
    return {
      // 按钮
      menuArr: [
        { name: "品牌活动" },
        { name: "媒体报道" },
        { name: "公司动态" },
      ],
      type: 0,
      pageNumber: 1,
      pageSize: 6,
      listTotal: 0,
      listArr: [],
      // 鼠标触摸下标
      mousemoveIndex: null,
    };
  },
  created() {
    this.pressCenterFun(this.type);
  },
  methods: {
    // 获取列表
    pressCenterFun(type) {
      let data = {
        type: type+1,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      }
      pressCenter(data).then((res) => {
        if (res.data.code == 10000) {
          this.listArr = res.data.data.list;
          this.listTotal = res.data.data.totalRow;
          console.log(res);
        }
      });
    },
    // 页码发生变法
    currentChange(e) {
      this.pageNumber = e;
      this.pressCenterFun(this.type)
    },
    // 点击分类
    goAnchor(index) {
      this.type = index;
      this.pageNumber = 1,
      this.pressCenterFun(this.type);
    },
    // 鼠标触摸列表
    listMove(index) {
      this.mousemoveIndex = index;
    },
    // 鼠标触摸离开
    listMoveLeave() {
      this.mousemoveIndex = null;
    },
    // 点击跳转详情
    listDetails(id) {
      this.$router.push("/newsCenter/newsCenterDetails?id=" + id);
    },
  },
};
</script>

<style scoped lang="less">
@import "../css/newsCenterIndex.less";
</style>
